import { createSharedComposable } from '@vueuse/core';

// eslint-disable-next-line regex/invalid
import { LoginModal, RequestPasswordResetModal, SessionExpiredModal, SignupModal, SignupOnboardingModal } from '#components';
import type { LoginModalProps } from '~/components/Login/LoginModal.vue';
import type { SignupModalProps } from '~/components/Signup/SignupModal.vue';

type UseModalsReturn = {
    openSignupModal: (props?: SignupModalProps) => void;
    closeSignupModal: () => void;

    openOnboardingModal: () => void;
    closeOnboardingModal: () => void;

    openLoginModal: (props?: LoginModalProps) => Promise<boolean>;
    closeLoginModal: () => void;

    openRequestPasswordResetModal: (props?: { email: string }) => void;
    closeRequestPasswordResetModal: () => void;

    openSessionExpiredModal: () => void;
    closeSessionExpiredModal: () => void;
};

export const _useModals = (): UseModalsReturn => {
    const overlay = useOverlay();
    const { isLoggedIn } = useAuthUtils();

    // MODALS
    const signupModal = overlay.create(SignupModal);
    const onboardingModal = overlay.create(SignupOnboardingModal);
    const loginModal = overlay.create(LoginModal);
    const requestPasswordResetModal = overlay.create(RequestPasswordResetModal);
    const sessionExpiredModal = overlay.create(SessionExpiredModal);

    return {
        openSignupModal: props => !isLoggedIn.value && !signupModal.isOpen && signupModal.open(props),
        closeSignupModal: () => signupModal.close(),

        openOnboardingModal: () => !onboardingModal.isOpen && onboardingModal.open(),
        closeOnboardingModal: () => onboardingModal.close(),

        openLoginModal: props => (isLoggedIn.value ? Promise.resolve(true) : loginModal.open(props)),
        closeLoginModal: () => loginModal.close(),

        openRequestPasswordResetModal: props => !isLoggedIn.value && requestPasswordResetModal.open(props),
        closeRequestPasswordResetModal: () => requestPasswordResetModal.close(),

        openSessionExpiredModal: () => sessionExpiredModal.open(),
        closeSessionExpiredModal: () => sessionExpiredModal.close(),
    };
};

export const useModals = createSharedComposable(_useModals);
